import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";

const SvgYellowMoneyLanding = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={65}
    height={65}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <circle cx={32.5} cy={32.5} r={32.5} fill="#FFCE00" fillOpacity={0.17} />

    {/* Perfected centering */}
    <g
      transform="translate(16.5,18) scale(0.8)"
      clipPath="url(#clip0_11410_668)"
    >
      <path
        d="M41.7578 0H5.98137C4.24845 0 2.79503 1.44228 2.79503 3.16192V18.1949C1.06211 20.1919 0 22.7991 0 25.6282C0 31.8966 5.14286 37 11.4596 37C17.2174 37 21.9689 32.7841 22.8075 27.2924H41.8137C43.6025 27.2924 45.0559 25.8501 45.0559 24.1304V3.16192C45 1.44228 43.5466 0 41.7578 0ZM11.4596 35.6132C5.92547 35.6132 1.39752 31.1199 1.39752 25.6282C1.39752 20.1364 5.92547 15.6432 11.4596 15.6432C16.9938 15.6432 21.5217 20.1364 21.5217 25.6282C21.5776 31.1754 17.0497 35.6132 11.4596 35.6132ZM43.6025 24.1304C43.6025 25.1289 42.764 25.9055 41.7578 25.9055H22.9193C22.9193 25.7946 22.9193 25.6837 22.9193 25.5727C22.9193 19.3043 17.7764 14.2009 11.4596 14.2009C8.7205 14.2009 6.14907 15.1994 4.19255 16.8081V3.16192C4.19255 2.21889 5.03106 1.38681 6.03727 1.38681H41.8137C42.764 1.38681 43.6025 2.21889 43.6025 3.16192V24.1304Z"
        fill="#FFCE00"
      />
      <path
        d="M35.0497 14.9775C34.3788 14.9775 33.708 15.144 33.149 15.4213C32.59 15.144 31.9192 14.9775 31.2484 14.9775C28.7329 14.9775 26.7205 16.9745 26.7205 19.4708C26.7205 21.967 28.7329 23.964 31.2484 23.964C31.9192 23.964 32.59 23.7976 33.149 23.5203C33.708 23.7976 34.3788 23.964 35.0497 23.964C37.5652 23.964 39.5776 21.967 39.5776 19.4708C39.5776 16.9745 37.5093 14.9775 35.0497 14.9775ZM34.3229 19.4708C34.3229 20.4693 33.8198 21.3569 33.0931 21.9116C32.3664 21.3569 31.8633 20.4693 31.8633 19.4708C31.8633 18.4723 32.3664 17.5847 33.0931 17.03C33.8757 17.5847 34.3229 18.4723 34.3229 19.4708ZM28.0621 19.4708C28.0621 17.7512 29.4596 16.3643 31.1925 16.3643C31.3602 16.3643 31.5279 16.3643 31.6956 16.4198C30.913 17.2519 30.4658 18.3059 30.4658 19.4708C30.4658 20.6357 30.913 21.7452 31.6956 22.5218C31.5279 22.5772 31.3602 22.5772 31.1925 22.5772C29.4596 22.5772 28.0621 21.1904 28.0621 19.4708ZM35.0497 22.5772C34.882 22.5772 34.7142 22.5772 34.5465 22.5218C35.3292 21.6897 35.7764 20.6357 35.7764 19.4708C35.7764 18.3059 35.3292 17.1964 34.5465 16.4198C34.7142 16.3643 34.882 16.3643 35.0497 16.3643C36.7826 16.3643 38.1801 17.7512 38.1801 19.4708C38.1801 21.1904 36.7826 22.5772 35.0497 22.5772Z"
        fill="#FFCE00"
      />
      <path
        d="M13.8075 19.4153C12.7454 19.4153 11.7392 19.8036 11.0125 20.5802L9.89444 21.6342C9.61494 21.9115 9.61494 22.3553 9.89444 22.6327C10.1739 22.91 10.6211 22.91 10.9007 22.6327L11.9628 21.5787C12.969 20.5802 14.5901 20.5802 15.5963 21.5787C16.0994 22.078 16.323 22.6881 16.323 23.4093C16.323 24.075 16.0435 24.7406 15.5963 25.2399L14.5342 26.1829C14.2547 26.4603 14.2547 26.904 14.5342 27.1814C14.646 27.2923 14.8696 27.4033 15.0373 27.4033C15.205 27.4033 15.3727 27.3478 15.5404 27.1814L16.6025 26.1274C17.3292 25.4063 17.7764 24.4078 17.7764 23.3538C17.7764 22.2998 17.3851 21.3013 16.6025 20.5802C15.8199 19.8036 14.8696 19.4153 13.8075 19.4153Z"
        fill="#FFCE00"
      />
      <path
        d="M12.0745 28.6792L11.0124 29.7331C10.0062 30.7316 8.38507 30.7316 7.37885 29.7331C6.37264 28.7346 6.37264 27.1259 7.37885 26.1274L8.44097 25.0735C8.72047 24.7961 8.72047 24.3523 8.44097 24.075C8.16146 23.7976 7.71426 23.7976 7.43476 24.075L6.37264 25.1289C5.64594 25.8501 5.19873 26.8486 5.19873 27.9026C5.19873 28.9565 5.59003 29.955 6.37264 30.6762C7.15525 31.3973 8.10556 31.8411 9.16767 31.8411C10.2298 31.8411 11.236 31.4528 11.9627 30.6762L13.0248 29.6222C13.3043 29.3448 13.3043 28.9011 13.0248 28.6237C12.7453 28.3463 12.2981 28.4018 12.0745 28.6792Z"
        fill="#FFCE00"
      />
      <path
        d="M13.0806 23.0764L8.944 27.1814C8.6645 27.4587 8.6645 27.9025 8.944 28.1799C9.0558 28.2908 9.27941 28.4018 9.44711 28.4018C9.61481 28.4018 9.78251 28.3463 9.95021 28.1799L14.0869 24.0749C14.3664 23.7976 14.3664 23.3538 14.0869 23.0764C13.8074 22.7991 13.3043 22.7991 13.0806 23.0764Z"
        fill="#FFCE00"
      />
      <path
        d="M7.93789 6.7676H21.7453C22.1366 6.7676 22.4721 6.43476 22.4721 6.04646C22.4721 5.65815 22.1366 5.32532 21.7453 5.32532H7.93789C7.54659 5.32532 7.21118 5.65815 7.21118 6.04646C7.21118 6.43476 7.54659 6.7676 7.93789 6.7676Z"
        fill="#FFCE00"
      />
      <path
        d="M27.1679 8.48725C27.1679 8.09895 26.8325 7.76611 26.4412 7.76611H7.60268C7.21138 7.76611 6.87598 8.09895 6.87598 8.48725C6.87598 8.87556 7.21138 9.20839 7.60268 9.20839H26.4412C26.8325 9.20839 27.1679 8.87556 27.1679 8.48725Z"
        fill="#FFCE00"
      />
      <path
        d="M23.9254 6.76767H26.4969C26.8882 6.76767 27.2236 6.43483 27.2236 6.04653C27.2236 5.65822 26.8323 5.38086 26.441 5.38086H23.8695C23.4782 5.38086 23.1428 5.71369 23.1428 6.102C23.1428 6.4903 23.5341 6.76767 23.9254 6.76767Z"
        fill="#FFCE00"
      />
    </g>

    <defs>
      <clipPath id="clip0_11410_668">
        <rect width="45" height="37" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgYellowMoneyLanding);
export default ForwardRef;
